@use 'styles/functions/rem' as *;

.toast {
    position: fixed;
    right: rem(50px);
    top: rem(50px);
    z-index: var(--toast-z-index);
}
